import { render, staticRenderFns } from "./ClientAccountSummaryFooter.vue?vue&type=template&id=4e3041c2&scoped=true"
import script from "./ClientAccountSummaryFooter.vue?vue&type=script&lang=js"
export * from "./ClientAccountSummaryFooter.vue?vue&type=script&lang=js"
import style0 from "./ClientAccountSummaryFooter.vue?vue&type=style&index=0&id=4e3041c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3041c2",
  null
  
)

export default component.exports